export const LEGALITYDOCUMENT_LOADING = "LEGALITYDOCUMENT_LOADING";
export const LEGALITYDOCUMENT_RESET = "LEGALITYDOCUMENT_RESET";
export const GET_LEGALITYDOCUMENT = "GET_LEGALITYDOCUMENT";
export const GET_LEGALITYDOCUMENT_SUCCESS = "GET_LEGALITYDOCUMENT_SUCCESS";
export const GET_LEGALITYDOCUMENT_FAIL = "GET_LEGALITYDOCUMENT_FAIL";
export const DELETE_LEGALITYDOCUMENT = "DELETE_LEGALITYDOCUMENT"
export const DELETE_LEGALITYDOCUMENT_SUCCESS = "DELETE_LEGALITYDOCUMENT_SUCCESS"
export const DELETE_LEGALITYDOCUMENT_FAIL = "DELETE_LEGALITYDOCUMENT_FAIL"
export const UPDATE_LEGALITYDOCUMENT = "UPDATE_LEGALITYDOCUMENT"
export const UPDATE_LEGALITYDOCUMENT_SUCCESS = "UPDATE_LEGALITYDOCUMENT_SUCCESS"
export const UPDATE_LEGALITYDOCUMENT_FAIL = "UPDATE_LEGALITYDOCUMENT_FAIL"
export const ADD_NEW_LEGALITYDOCUMENT = "ADD_NEW_LEGALITYDOCUMENT"
export const ADD_LEGALITYDOCUMENT_SUCCESS = "ADD_LEGALITYDOCUMENT_SUCCESS"
export const ADD_LEGALITYDOCUMENT_FAIL = "ADD_LEGALITYDOCUMENT_FAIL"